/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryComponent } from './inventoryComponent';
import { InventoryStats } from './inventoryStats';
import { InventoryHealth } from './inventoryHealth';


/**
 * Combined Health and Stats with Inventory details in Provider Agent format
 */
export interface IrrComponentsRawData { 
    inventory_components: Array<InventoryComponent>;
    inventory_health: InventoryHealth;
    inventory_stats: InventoryStats;
}

